/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { useTranslation } from "react-i18next";
import { AuroraBackground } from "@/components/AuroraBackground";
import { Reveal } from "@/components/Reveal";
import { StoreBadgeGroup } from "@/components/StoreBadges";

const StoryPage = () => {
  const { t } = useTranslation("site");
  const tk = (k, fb) => t(`story.${k}`, fb);
  return (
    <>
      <section className="relative pb-8">
        <AuroraBackground variant="gold" />
        <div className="relative mx-auto max-w-3xl px-5 lg:px-8 pt-8 lg:pt-12">
          <Reveal>
            <p className="eyebrow">{tk("kicker")}</p>
            <h1 className="mt-3 font-serif text-[2.4rem] sm:text-5xl lg:text-[4rem] tracking-tight font-light leading-[1.05]">
              {tk("title1")}{" "}<em className="italic aurora-shimmer-text">{tk("title2")}</em>
            </h1>
          </Reveal>
        </div>
      </section>

      <article className="relative py-12">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 space-y-10 text-white/82 font-light text-lg leading-[1.75]">
          <Reveal><p>{tk("p1")}</p></Reveal>
          <Reveal><p>{tk("p2")}</p></Reveal>
          <Reveal><p>{tk("p3")}</p></Reveal>
          <Reveal><p>{tk("p4")}</p></Reveal>
          <Reveal>
            <p className="font-serif italic text-2xl text-[var(--aurora-gold)]/90 border-l-2 border-[var(--aurora-gold)]/60 pl-6">
              {tk("quote")}
            </p>
          </Reveal>
        </div>
      </article>

      <section className="relative py-16">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 text-center">
          <Reveal>
            <h2 className="font-serif text-3xl tracking-tight font-light">{tk("closing")}</h2>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <StoreBadgeGroup startLabel={t("common.startFree")} />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default StoryPage;
